import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import cx from "classnames";
import { ProposalStatus } from "../../graphql/generated/proposals.sdk";
import { Text } from "@sundae/ui-toolkit";
export const StatusPill = ({ status, size, className, ...rest }) => {
    const statusClass = useMemo(() => {
        switch (status) {
            case ProposalStatus.New:
                return "bg-primary-200 status-new";
            case ProposalStatus.Defeated:
                return "bg-error-200 status-defeated";
            case ProposalStatus.Executed:
            case ProposalStatus.Finished:
                return "bg-gray-400 dark:bg-gray-600 !dark:text-black status-finished";
            case ProposalStatus.Ongoing:
            default:
                return "bg-success-200 status-ongoing";
        }
    }, [status]);
    return (_jsx(Text, { tag: "span", size: size || "xs", weight: "normal", className: cx("rounded-full px-4 py-1 uppercase", statusClass, className), ...rest, children: status }));
};
export default StatusPill;
//# sourceMappingURL=StatusPill.js.map